import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export type Crumb = {
  label: string;
  to?: string;
};

/**
 * Compact breadcrumbs trail for admin sub-pages. Last segment renders as
 * plain text (the current page), all others are links to their parent.
 *
 * Example: `<Breadcrumbs crumbs={[{label:'Admin', to:'/admin'}, {label:'Users'}]} />`
 */
export function Breadcrumbs({ crumbs }: { crumbs: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="text-xs uppercase tracking-widest text-cabinet-cream/60">
      <ol className="flex flex-wrap items-center gap-1">
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {!isLast && c.to ? (
                <Link
                  to={c.to}
                  className="hover:text-cabinet-gold underline-offset-2 hover:underline"
                >
                  {c.label}
                </Link>
              ) : (
                <span
                  aria-current={isLast ? 'page' : undefined}
                  className={cn(isLast && 'text-cabinet-gold-bright')}
                >
                  {c.label}
                </span>
              )}
              {!isLast && <span className="text-cabinet-cream/30">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
